import * as React from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { GetConsumerDetailedQuery } from '@graphql';
import { EmptyState } from '../../common';
import { Restricted } from '../Restricted';

interface MemoriesProps {
  consumer: GetConsumerDetailedQuery['consumer'];
}

function Memories(props: Readonly<MemoriesProps>) {
  const { consumer } = props;
  const { t } = useTranslation('account');

  return (
    <Stack spacing={5} p={3}>
      {consumer.isMyFriend ? <EmptyState text={t('text.No memory yet')} /> : <Restricted />}
    </Stack>
  );
}

export default React.memo(Memories);
